// extracted by mini-css-extract-plugin
export default {"card":"foundation_card__xnh3P"};